import { styled } from '@material-ui/core/styles';
import { Fab } from '@material-ui/core';
import * as Colors from '../styles/colors';

export default styled(Fab)({
    borderRadius: 10,
    backgroundColor: Colors.baseColors.lightBlue,
    color: "white",
    boxShadow: "none"
});